export interface fmfFormValue {
    institutionId: number | null,
    creationDate: Date | null,
    status: string,
    patientId: number | null,
    chestPerimeter: number | null,
    correctionPressure: number | null,
    pcPosition: string | number,
    model: string,
    size: number | null,
    mammaryDevelopment: string,
    observations: string,
}
